export default "__VITE_ASSET__DRhxxq2U__"